export default {
  welcome: 'Olá, {{name}}',
  needHelp: 'Precisa de ajuda?'
}
